import React from 'react';
import { Button } from 'react-bootstrap';
import './index.css';
import {useSelector} from "react-redux";
import useMediaQuery from "../../../hooks/useMediaQuery";

const FAB = ({ onClick, content, disabled = false }) => {
    const isMobileScreen = useMediaQuery("(max-width: 980px)");
    const isDrawerOpen = useSelector((state) => state.ACTIVITY.showFooterDrawer);
    return (
        <Button
            disabled={disabled}
            onClick={onClick}
            style={{bottom: (isMobileScreen && !isDrawerOpen) ? "5vh" : "revert-layer" }}
            variant="primary"
            className="fab">
            {content}
        </Button>
    );
};

export default FAB;
